import { useTheme } from "@reactive-resume/hooks";
import { cn } from "@reactive-resume/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Logo = ({ size = 32, className }: Props) => {
  const { isDarkMode } = useTheme();

  return (
    <svg
      className={cn("text-primary", className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 297.67 208.64"
      width={size}
      height={size}
    >
      <path
        fill="currentColor"
        d="M297.49 204.49c-.18.32-2.05 1.11-2.62 1.13l-36.92-.04-3.06-3.03-13.55-27.96c-1.04-.23-.68.45-.99.99-3.95 6.89-6.64 13.82-12.49 19.53-19.95 19.51-59.95 16.66-80.51-.53-22.52-18.83-28.12-57.61-47.57-77.44-21.03-21.44-68.83-3.77-62.48 30.48 2.76 14.9 11.12 21.6 26.03 22.97 3.97.36 8.49-1.8 9.2 3.3.83 5.99.64 22.22.06 28.48-.33 3.64-1.66 4.72-5.31 5.19-30.58 3.96-60.53-23.54-65.95-52.46-10.54-56.23 43.26-95.01 95.36-80.37 37.09 10.43 47.31 44.29 63.81 74.2 5.9 10.69 18.66 32.9 33.52 24.35 6.53-3.76 12.95-18.88 16.5-26 10.19-20.45 19.44-41.42 29.64-61.86 1.33-2.67 4.56-10.44 7.06-11.44l41.02-.28c1.44.43 1.66 2.18 1.12 3.41l-26.77 54.2c10.38 24.03 23.2 46.89 34.61 70.43.32.76.7 2.03.29 2.76Z"
      />

      <g>
        <path
          fill="currentColor"
          d="M81.98.23c40.64-4.43 44.79 56.32 6.35 59.35C49.01 62.68 45.01 4.26 81.98.23Z"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="translate"
            values="
              0 0;
              20 5;
              35 10;
              40 20;
              30 8;
              0 0;
              0 0
            "
            keyTimes="0; 0.2; 0.3; 0.4; 0.5; 0.6; 1"
            dur="12s"
            repeatCount="indefinite"
          />
        </path>
      </g>
    </svg>
  );
};
